<i :class="{ selected: isFavorite(id) }" @click.stop.prevent="toggle" class="fa-solid fa-heart" :disabled="toggling"></i>
